import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "CodeModalDeaktivieren",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    obj: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
    };
  },
  computed: {
    translationMsgSuccess() {
      return {
        text: "_MSG_CODE_TABLE_MODAL_DEACTIVATE_SUCCESS_{{code}}_",
        extra: { code: this.obj.co_code }
      };
    },

    translationMsgError() {
      return {
        text: "_MSG_CODE_TABLE_MODAL_DEACTIVATE_ERROR_{{code}}_",
        extra: { code: this.obj.co_code }
      };
    },
  },
  methods: {
    deactivateCode() {
      this.status.loading = true;
      const data = cloneDeep(this.obj);
      data.co_deaktiviert = true;
      this.putHttp({ url: `codes/${ this.obj.pk }/`, data }).then(
        response => {
          this.addNotification(this.translationMsgSuccess);
          this.close({ response });
        },
        () => this.addNotification(this.translationMsgError)
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
